import { first, isArray, last } from 'lodash'

export const castTokenColors = (colors) => {
  const tokens = {}
  Object.keys(colors).map(item => {
    Object.keys(colors[item]).map(color => {
      tokens[`${item}${color}`] = colors[item][color]
    })
  })
  return tokens
}

export const parseVariants = (variants) => isArray(variants) ? {
  '@initial': first(variants),
  '@lg': last(variants)
} : variants
